import { render, staticRenderFns } from "./avatarItem.vue?vue&type=template&id=312dcf88&scoped=true&"
import script from "./avatarItem.vue?vue&type=script&lang=js&"
export * from "./avatarItem.vue?vue&type=script&lang=js&"
import style0 from "./avatarItem.vue?vue&type=style&index=0&id=312dcf88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312dcf88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
